import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { DeepLinkAliasField } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';

import { GroupType } from 'APP/model/group/groupModel.types';

import { IChannelFormData } from '../ChannelForm.types';

export const ChannelDeepLinkAliasField: FC<FieldRenderProps<string, HTMLInputElement>> = ({
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <DeepLinkAliasField
      title={t('common_invite_link')}
      description={t('channel_deeplink_prompt')}
      placeholder={t('common_link')}
      validatingText={t('checking_deeplink')}
      successText={t('channel_link_is_available')}
      isShowLink={(values: IChannelFormData): boolean => values.type === GroupType.ChannelOpen}
      {...props}
    ></DeepLinkAliasField>
  );
};
